import { Link } from 'react-router-dom';

function AboutPage() {
  return (
    <div className="about-page">
      <div className="about-container">
        <div className="about-header">
          <h1 className="about-title">About this App</h1>
          <p className="about-subtitle">
            This application is an independent, physics-based utility designed to provide qualitative data for heating system comparisons.
          </p>
        </div>

        <div className="about-content">
          <section className="about-section">
            <h2 className="section-title">Neutrality Disclosure</h2>
            
            <div className="disclosure-item">
              <h3 className="disclosure-title">Independent Development</h3>
              <p className="disclosure-text">
                This app is not affiliated with, endorsed by, or representative of British Gas, Centrica, or any other energy provider.
              </p>
            </div>

            <div className="disclosure-item">
              <h3 className="disclosure-title">Data Basis</h3>
              <p className="disclosure-text">
                Insights are generated using public manufacturer data and general thermodynamic principles. It is intended for informational purposes and does not replace professional site surveys or specific commercial advice.
              </p>
            </div>

            <div className="disclosure-item">
              <h3 className="disclosure-title">Views Expressed</h3>
              <p className="disclosure-text">
                Any methodology or data presentation herein reflects the independent research of the author and does not represent the official stance or proprietary methods of any external organization.
              </p>
            </div>
          </section>

          <section className="about-section">
            <h2 className="section-title">Purpose</h2>
            <p className="disclosure-text">
              This tool provides neutral, physics-based analysis to help users understand heating system options for UK properties. 
              All recommendations are based on publicly available data and standard thermodynamic calculations.
            </p>
          </section>

          <section className="about-section">
            <h2 className="section-title">Intellectual Property</h2>
            <p className="disclosure-text">
              This software is a personal project developed entirely by the author in their private capacity. 
              All rights, title, and interest in the source code, logic, and design are held by the author. 
              No part of this project was created "in the course of employment."
            </p>
          </section>
        </div>

        <div className="about-footer">
          <Link to="/" className="back-button">← Back to Home</Link>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
